import * as types from './mutation-types'

export const doAuthentication = ({ commit }, success) => commit(types.AUTHENTICATED, success)

export const toggleSidebar = ({ commit }, opened) => commit(types.TOGGLE_SIDEBAR, opened)

export const toggleDevice = ({ commit }, device) => commit(types.TOGGLE_DEVICE, device)

export const expandMenu = ({ commit }, menuItem) => {
  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false
    commit(types.EXPAND_MENU, menuItem)
  }
}

export const switchEffect = ({ commit }, effectItem) => {
  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem)
  }
}
export const storeDateTimeTimesheet = ({ commit }, datetime) => {
  commit(types.DATETIME_TIMESHEET, datetime)
}

export const storeDateTimeOTStatus = ({ commit }, datetime) => commit(types.DATETIME_OTSTATUS, datetime)

export const storeDateTimeTotalOT = ({ commit }, datetime) => commit(types.DATETIME_TOTALOT, datetime)

export const storeDateTimeTimesheetList = ({ commit }, datetime) => commit(types.DATETIME_TIMESHEETLIST, datetime)

export const allowanceSwitch = ({ commit }, value) => commit(types.ALLOWANCE_SWITCH, value)



// WEBPACK FOOTER //
// ./client/store/actions.js